<div class="form-header">
  <div *ngIf="edited.id && edited.id > 0">Edit 
    reminder</div>
  <div *ngIf="!edited.id || edited.id === -1">Add 
    reminder</div>
</div>


<form [formGroup]="reminderForm" (ngSubmit)="onSubmitForm(reminderForm)" >
  
<div class="dialog-container" >
    <div class="field" required>
      <mat-form-field >
        <mat-label>Title</mat-label>
        <textarea class="description-field" rows="1" columns="50" maxlength="256" matInput formControlName="title" name="title"></textarea>
      </mat-form-field>
    </div>
    <div class="field" required >
      <mat-form-field >
        <mat-label>Text</mat-label>
        <textarea class="description-field" rows="3" columns="50" maxlength="2552" matInput formControlName="text" name="text"></textarea>
      </mat-form-field>
    </div>
    <div class="select-panel">
      <div class="select-field" required >
        <mat-form-field appearance="fill">
          <mat-label>Frequency</mat-label>
          <mat-select (selectionChange)="frequencyChanged($event)" formControlName="frequency">
            <mat-option *ngFor="let frequency of frequencies" [value]="frequency">{{frequency}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="select-field" required >
        <mat-form-field appearance="fill">
          <mat-label>On These Days</mat-label>
          <mat-select  [disabled]="getFrequency() === 'Daily' || getFrequency() === 'Never'" formControlName="atDays" multiple>
            <mat-option *ngFor="let day of days" [value]="day">{{day}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="select-field" required >
        <mat-form-field appearance="fill">
          <mat-label>At These Times</mat-label>
          <mat-select  formControlName="atTimes" multiple>
            <mat-option *ngFor="let time of times" [value]="time">{{time}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="select-field" required >
        <mat-form-field appearance="fill">
          <mat-label>End date</mat-label>
          <input matInput formControlName="endDate" [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker  #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="button-container">
    <button class="dialog-button" [disabled]="isFormInValid()" type="submit" mat-flat-button color="primary" >Save</button>
    <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
  </div>

</form>